import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'
import { createStore } from 'redux';
//import { Provider } from 'react-redux'


var initialState = 0;

function pSize(state = initialState, action) {
    switch (action.type) {
    case 'CHANGE':
      return action.text;

    default:
      return state
  }
}


var store = createStore(pSize);

var resChange = function(text) {
  store.dispatch({ type: 'CHANGE', text: text });
}

ReactDOM.render((
  <BrowserRouter>
    <App resChange={resChange} store={store}/>
  </BrowserRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js